import React from "react";
import { Link } from "react-router-dom";
import { Share2 } from "lucide-react";

const ShareButton: React.FC<{ to: string }> = ({ to }) => {
  return (
    <Link
      to={to}
      className="flex items-center justify-center gap-2 px-4 py-2 bg-gradient-to-r from-purple-500 to-blue-500 text-white font-semibold rounded-lg shadow-md hover:shadow-lg hover:scale-105 transition-all duration-300"
      title="Share"
    >
      <span>Invite & Win</span>
      <Share2 className="w-5 h-5" />
    </Link>
  );
};

export default ShareButton;
